module.exports = __webpack_public_path__ + "media/images/common/credit_cards/diners-284ac915f7d1813aca868487a3969d46.svg";